var exports = {
  "M": "CopyLinkSection.module__linkFooter___MDBUOV",
  "e": "CopyLinkSection.module__linkSectionLabel___MDBUOV",
};

module.exports = exports;
